export default {
  trainingDataHeadline: 'Tréningové dáta',
  outputDataHeadline: 'Originál vs. predpoveď',
  inputDataHeadline: 'Vstupné dáta',
  modelConfigHeadline: 'Parametre modelu',
};
